import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import Navigation from "../model/Navigation";

export default class GenericPopupMediator extends AbstractPopupMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameConfig, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameConfig = gameConfig;
        this._gameModel = gameModel;
    }

    initialize() {
        super.initialize();

        //TODO: fix TECH DEBT: this is a generic popup, but it is used for a specific purpose here...
        this.applyText(this._target.titleTextfield, this.getText(`skipPracticePopup.title`));
        this.applyText(this._target.bodyTextfield, this.getText(`skipPracticePopup.body`));

        this._practiceAgain = this.createButton(this._target.continueButton, this._handlePracticeAgain.bind(this), this.getText(`skipPracticePopup.buttonPracticeAgain`));
        this._startGame = this.createButton(this._target.cancelButton, this._handleStartGame.bind(this), this.getText(`skipPracticePopup.buttonStartGame`));
    }

    _handlePracticeAgain() {
        this._close(Navigation.BACK);
    }

    _handleStartGame() {
        this._close(Navigation.OK);
    }
    _close(payload) {
        this._practiceAgain.setEnabled(false);
        this._startGame.setEnabled(false);
        this.close(payload);
    }
}